import { Link } from 'react-router-dom';
import PostCard from '@/components/base/PostCard';
import { posts } from '@/mocks/posts';

export default function HotBoard() {
  const ranked = [...posts].sort((a, b) => b.heat - a.heat).slice(0, 6);
  const latest = [...posts].sort((a, b) => b.publishedAt.localeCompare(a.publishedAt)).slice(0, 4);

  return (
    <section className="w-full px-4 py-10 md:px-8" aria-labelledby="hot-heading">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="lg:col-span-1">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <div className="mb-3 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill" aria-hidden="true"></i>
              </span>
              <h2 id="hot-heading" className="font-heading text-xl font-bold text-foreground-950">
                今日热榜
              </h2>
            </div>
            <p className="mb-2 text-xs text-foreground-500">按热度实时排序 · 每小时刷新一次</p>
            <div className="divide-y divide-background-200">
              {ranked.map((post, index) => (
                <PostCard key={post.id} post={post} variant="compact" rank={index + 1} />
              ))}
            </div>
            <Link
              to="/category/deep"
              className="mt-4 flex items-center justify-center gap-1 rounded-md border border-background-300 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              查看完整榜单
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </div>

        <div className="lg:col-span-2">
          <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
            <div>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">最新猛料</h2>
              <p className="mt-2 text-sm text-foreground-600">刚刚整理的爆料，热度还在往上冲。</p>
            </div>
            <span className="flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
              <i className="ri-refresh-line" aria-hidden="true"></i>
              每 30 分钟更新
            </span>
          </div>
          <div className="flex flex-col gap-4">
            {latest.map((post) => (
              <PostCard key={post.id} post={post} variant="wide" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}